<mat-card>
  <h2 translate>
    {{ title }}
  </h2>
  <mat-card-content>
    <div fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch">
      <div fxFlex="100" fxLayout="row" fxLayoutAlign="start start" class="header" *ngIf="searchType !== 0">
        <mat-label class="label-admin" translate>searchTable.adminUser</mat-label>
        <mat-icon class="icon-ic_chevron_right"></mat-icon>
        <!-- TODO: HAY QUE IMPLEMENTAR LA LOGICA DE LA PRIMERA LINEA, LA DE USUARIO ADMIN > ... -->
      </div>
      <div fxFlex="100" *ngIf="searchType === 0">
        <form (ngSubmit)="filterUsers()" [formGroup]="searchUserForm">
          <div fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
            <mat-form-field fxFlex="35" appearance="outline" class="filter-input">
              <mat-label translate>searchTable.filterCriteria</mat-label>
              <input
                #filterCriteriaSearchTable
                id="filterCriteriaSearchTable"
                formControlName="filterCriteria"
                matInput
                autocomplete="off"
              />
              <mat-error *ngIf="searchUserForm.controls.filterCriteria.hasError('required')" translate>
                field.required
              </mat-error>
            </mat-form-field>
            <div fxFlex="10" class="filter-button-box">
              <button
                id="filterUsersButtonSearchTable"
                mat-flat-button
                color="accent"
                fxFlex
                type="submit"
                [innerHTML]="'searchTable.filterButton' | translate"
              ></button>
            </div>
          </div>
        </form>
      </div>

      <div fxFlex="100" class="table__wrapper">
        <table aria-label="search-table" mat-table [dataSource]="dataSource" *ngIf="hasData(); else showNoOperations">
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell--icon">
              <mat-label translate>treeSearch.user</mat-label>
            </th>
            <td mat-cell *matCellDef="let element" class="centered">
              <div *ngIf="element.user; else showEmpty">
                <button id="editDataButtonSearchByCommercial" mat-icon-button (click)="onClickEditData(element)">
                  <mat-icon class="icon-ic_list_edit"></mat-icon>
                </button>
                <mat-label>{{ element.user }}</mat-label>
              </div>
              <ng-template #showEmpty>
                <mat-label>N</mat-label>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.userName</th>
            <td mat-cell *matCellDef="let element">
              <a (click)="searchSubordinates(element)">{{ element.userName }}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.type</th>
            <td mat-cell *matCellDef="let element">{{ element.type }}</td>
          </ng-container>
          <ng-container matColumnDef="division">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.division</th>
            <td mat-cell *matCellDef="let element">{{ element.division }}</td>
          </ng-container>
          <ng-container matColumnDef="hostCode">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.codHost</th>
            <td mat-cell *matCellDef="let element">{{ element.hostCode }}</td>
          </ng-container>
          <ng-container matColumnDef="activated">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.Active</th>
            <td mat-cell *matCellDef="let element" class="centered">{{ element.activated }}</td>
          </ng-container>
          <ng-container matColumnDef="atributions">
            <th mat-header-cell *matHeaderCellDef translate>treeSearch.Attributions</th>
            <td mat-cell *matCellDef="let element">
              <p *ngFor="let atribution of element.atributions" class="atributions">{{ atribution }},</p>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <ng-template #showNoOperations>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-label class="panel-request__label-no-operation" translate>request.noOperations</mat-label>
        </div>
      </ng-template>

      <div fxLayout="row" fxLayoutAlign="end center" class="footer" *ngIf="hasData()">
        <div>
          <mat-label translate>searchTable.totalOfRegisters</mat-label>
        </div>
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="footer--buttons"
          (click)="onClickPreviousPage()"
          *ngIf="hasPreviousKey"
        >
          <mat-icon class="icon-ic_chevron_left"></mat-icon>
        </button>
        <button
          id="nextPageRequestPanel"
          mat-flat-button
          class="footer--buttons"
          (click)="onClickNextPage()"
          *ngIf="hasNextKey"
        >
          <mat-icon class="icon-ic_chevron_right"></mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
